import { render, staticRenderFns } from "./QuotationLineItems-New.vue?vue&type=template&id=460d6ef1&scoped=true&"
import script from "./QuotationLineItems-New.vue?vue&type=script&lang=js&"
export * from "./QuotationLineItems-New.vue?vue&type=script&lang=js&"
import style0 from "./QuotationLineItems-New.vue?vue&type=style&index=0&id=460d6ef1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "460d6ef1",
  null
  
)

export default component.exports